import React from 'react';

export default function ModalConfirmar({ mensagem, extra, onConfirmar, onCancelar }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
    }}>
      <div style={{
        background: '#fff', borderRadius: 12, padding: 32, maxWidth: 420, width: '90%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.25)', textAlign: 'center'
      }}>
        <div style={{ fontSize: 44, marginBottom: 16 }}>⚠️</div>
        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a2e', marginBottom: 10 }}>
          Confirmar exclusão
        </h2>
        <p style={{ color: '#6b7280', fontSize: 15, marginBottom: extra ? 14 : 28, lineHeight: 1.5 }}>
          {mensagem}
        </p>
        {extra && <div style={{ marginBottom: 24, textAlign: 'left' }}>{extra}</div>}
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <button
            onClick={onCancelar}
            style={{ background: '#f3f4f6', color: '#374151', padding: '10px 24px', fontSize: 14, fontWeight: 500 }}
          >
            Cancelar
          </button>
          <button
            onClick={onConfirmar}
            style={{ background: '#dc2626', color: '#fff', padding: '10px 24px', fontSize: 14, fontWeight: 600 }}
          >
            Sim, excluir
          </button>
        </div>
      </div>
    </div>
  );
}
